import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=696404a6&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696404a6",
  null
  
)

component.options.__file = "Chat.vue"
export default component.exports